import script from "./FooterBig.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterBig.vue?vue&type=script&setup=true&lang=js"

import "./FooterBig.vue?vue&type=style&index=0&id=0313a9e6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0313a9e6"]])

export default __exports__